<template>
        <v-app-bar v-if="this.$store.state.authorized" app flat clipped-right :color="this.$vuetify.theme.dark ? '#000000' : '#ffffff'">
        <v-app-bar-nav-icon @click="toggleNavigationBar()"></v-app-bar-nav-icon>
        <v-toolbar-title>
            <v-img v-if="this.$vuetify.theme.dark" height="20" width="120"
                :src="require('@/assets/logo-dark.png')"></v-img>
            <v-img v-else height="20" width="120" :src="require('@/assets/logo-light.png')"></v-img>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleTheme()">
            <v-icon>mdi-theme-light-dark</v-icon>
        </v-btn>
        <v-btn icon to="/settings">
            <v-icon>mdi-cog</v-icon>
        </v-btn>
        <v-btn icon @click="toggleAgentBar()">
            <v-icon>mdi-creation</v-icon>
        </v-btn>
        <v-btn v-if="showPersonaSwitcher" icon @click="showPersonas = true;">
            <v-icon>mdi-account-switch</v-icon>
        </v-btn>
        <v-btn icon href="/profile">
            <v-avatar color="primary" class="white--text" >
                {{
                (userInfo.given_name != null
                ? userInfo.given_name.substring(0, 1)
                : null
                ).concat(
                userInfo.family_name != null ? userInfo.family_name.substring(0, 1) : null
                )
                }}
        </v-avatar>
        </v-btn>
        <v-dialog v-model="showPersonas" scrollable max-width="600">
            <v-card flat>
                <v-toolbar flat>
                    <v-btn icon @click="showPersonas = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ $t('SIGN_IN_AS') }}</v-toolbar-title>
                </v-toolbar>
                <v-divider></v-divider>
                <v-list dense two-line>
                    <v-list-item v-for="(item, index) of userTypes" :key="index">
                        <v-list-item-avatar>
                            <v-icon>
                                mdi-account
                            </v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.name }}
                            </v-list-item-title>
                            <div class="grey--text caption">
                                {{ item.description }}
                            </div>
                        </v-list-item-content>
                        <v-list-item-action v-if="item.type === userInfo.type">
                            <v-icon color="success">mdi-check-circle</v-icon>
                        </v-list-item-action>
                        <v-list-item-action v-else-if="item.type !== 'ADMINISTRATOR' && userInfo.type !== 'ADMINISTRATOR'">
                           &nbsp;
                        </v-list-item-action>
                        <v-list-item-action v-else>
                            <v-btn icon @click="showPersonas = false; switchUser(item)">
                                <v-icon color="primary">mdi-login</v-icon>
                            </v-btn>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-dialog>
    </v-app-bar>
</template>

<script>
export default {
    name: "DefaultView",
    data() {
        return {
            showPersonas: false,
            showNavigationBar: true,
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        showPersonaSwitcher() {
            return this.$store.state.metadata.showPersonaSwitcher;
        },
        userTypes() {
            return this.$store.state.metadata?.userTypes;
        },
        currentUserType() {
            const user = this.userTypes?.find(user => user.type === this.$store.state.userInfo.type);
            if (user) {
                return user.name;
            } else {
                return '';
            }
        },
    },
    methods: {
        toggleTheme() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
            this.$cookies.set("app.darkMode", this.$vuetify.theme.dark);
        },
        toggleAgentBar() {
            this.$emit("toggleAgentBar");
        },
        toggleNavigationBar() {
            this.showNavigationBar = !this.showNavigationBar;
            this.$emit("toggleNavigationBar");
        },
        switchUser(user) {
            if (user.username && user.username === this.$store.state.userInfo.username) return;
            let userId = this.userTypes?.find(u => u.type === user.type).userId;
            if (userId) {
                this.$router.push("/signin").then(() => {
                    this.signInAs(userId);
                }).catch((error) => {
                    console.log(error);
                });
            } else {
                this.$router.push("/signin").then(() => {
                    this.refreshToken();
                }).catch((error) => {
                    console.log(error);
                });
            }
        },
        refreshToken() {
            this.$store.dispatch('refreshToken')
                .then(() => {
                    this.$router.push("/home");
                }).catch((error) => {
                    console.log(error);
                })
        },
        signInAs(userId) {
            this.$store.dispatch('signInAs', {
                subject: userId
            }).then(() => {
                this.$router.push("/home");
            }).catch((error) => {
                console.log(error);
            })
        }
    }
};
</script>

<i18n>
{
  "en": {
    "SIGN_IN_AS": "Sign in as"
  }
}
</i18n>

